export default __webpack_public_path__ + "static/media/MorningstarPharma.8f42661d.png";